<template lang="pug">
  ld-app-layout(:title="title" :activeApp="activeApp" @toggle:drawer="persistDrawerState")
    template(slot="search")
      create-contact-button
      contact-search(@update:search="redirectToContactPage")
      create-contact-modal
      ld-change-profile-picture-modal
    slot
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { LdAppLayout, LdChangeProfilePictureModal } from 'lion-vue';
import UtilityNav from '@/Core/components/navigation/Utility';
import ContactSearch from '@/Core/components/navigation/ContactSearch';
import CreateContactButton from '@/Contacts/components/CreateContactButton';
import CreateContactModal from '@/Contacts/components/CreateContactModal';
// TODO ak:
//
// Outstanding issues with shared app layout
// 1. Persist left nav expanded state
//    (shared comps uses plugin to persist all vuex values, need to revisit)
// 2. Huge dependencies - e.g. @vue/cli-shared-utils ~ 1MB minified
export default {
  components: {
    LdAppLayout,
    LdChangeProfilePictureModal,
    UtilityNav,
    ContactSearch,
    CreateContactModal,
    CreateContactButton,
  },
  data() {
    return {
      title: 'LionDesk',
      activeApp: 'crm',
      drawer: true,
      notify: 0,
      navigation: [
        {
          id: 'home',
          icon: 'dashboard',
          title: 'Home',
          route: { name: 'dashboard' },
        },
        {
          id: 'contacts',
          icon: 'contacts',
          title: 'Contacts',
          route: { name: 'contacts' },
        },
        {
          id: 'communication',
          icon: 'mail_outline',
          title: 'Communication',
          route: { name: 'communications' },
        },
        {
          id: 'tasks',
          icon: 'event_note',
          title: 'Tasks',
          route: { name: 'tasks' },
        },
        {
          id: 'campaigns',
          icon: 'flight_takeoff',
          title: 'Campaigns',
          route: { name: 'campaigns' },
        },
        {
          id: 'videos',
          icon: 'videocam',
          title: 'Videos',
          route: { name: 'videos' },
        },
        {
          id: 'marketing',
          icon: '$vuetify.icons.bullhorn',
          title: 'Marketing',
          route: { name: 'marketing' },
          app: 'crm',
        },
        {
          id: 'leadsplusreporting',
          icon: '$vuetify.icons.leads-plus',
          title: 'Leads+',
          route: { name: 'leadsplusreporting' },
          app: 'crm',
        },
        {
          id: 'documents',
          icon: 'folder',
          title: 'Documents',
          route: { name: 'documents' },
          app: 'crm',
        },
        {
          id: 'transactions',
          icon: 'credit_card',
          title: 'Transactions',
          external: process.env.VUE_APP_TX_URL,
        },
        {
          id: 'mls',
          icon: 'home',
          title: 'Visual Market Insights',
          external: process.env.VUE_APP_MLS_URL,
        },
        {
          id: 'reporting',
          icon: 'insert_chart_outlined',
          title: 'Reporting',
          route: { name: 'reporting' },
          app: 'crm',
        },
        {
          id: 'onlinehelp',
          icon: 'help',
          title: 'Online Help',
          external: 'https://lonewolf.my.site.com/s/liondesk-resources',
          target: '_blank',
        },
        {
          id: 'refer',
          icon: 'favorite',
          title: 'Refer a friend',
          route: { name: 'refer' },
          app: 'crm',
        },
        // {
        //   id: 'notifications',
        //   icon: 'textsms',
        //   title: 'Notifications',
        //   route: '/home/notifications',
        // },
        // {
        //   id: 'reports',
        //   icon: 'show_chart',
        //   title: 'Reports',
        //   route: '/home/reports',
        // },
        // {
        //   id: 'documents',
        //   icon: 'folder',
        //   title: 'Documents',
        //   route: '/home/documents',
        // },
        // {
        //   id: 'add-feature',
        //   icon: 'add',
        //   title: 'New Application',
        //   route: '/home/appstore',
        // },
      ],
    };
  },
  computed: {
    ...mapState({
      navBarExpanded: state => state.preferences.navBarExpanded,
      user: state => state.userInformation.user,
    }),
    isLegacyUser() {
      if (this.user) {
        return this.user.account_version < 2;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      updatePreference: 'preferences/updatePreference',
    }),
    persistDrawerState(state) {
      this.updatePreference({ key: 'navBarExpanded', value: state });
    },
    redirectToContactPage(id) {
      if (id) {
        this.$router.push({ name: 'contact-profile', params: { id } });
      }
    },
    async logout() {
      await this.$store.dispatch('authentication/logout');
      const redirect = encodeURIComponent(window.location.href);
      const newLocation = `${process.env.VUE_APP_ACCOUNTS_APP_URL}/signin?ref=${redirect}`;
      window.location.assign(newLocation);
    },
  },
};
</script>
<style lang="scss" scoped>
/* TODO AK: refactor this into a common stylesheet */
.router-link,
.router-link-active {
  text-decoration: none;
}
.v-navigation-drawer {
  z-index: 5;
}
.v-navigation-drawer--mini-variant {
  z-index: 5;
  .logo img {
    margin-left: -2px;
  }
}
.logo {
  white-space: nowrap;
  height: 64px;
  padding: 4px 12px 0;
  border-bottom: solid 1px #eee;
  img {
    height: 64px;
    width: 64px;
    vertical-align: middle;
    margin-left: -12px;
  }
  &:after {
    content: 'TM';
    position: relative;
    font-size: 5px;
    width: 10px;
    height: 10px;
    color: var(--v-primary-base);
    top: -20px;
    right: 14px;
  }
}
.v-toolbar {
  z-index: 3;
}
.back-to-v1 {
  position: absolute;
  /deep/ .v-list__tile__title {
    white-space: normal;
  }
}
.resizable {
  height: calc(100% - 64px);
}
.scrollable {
  overflow-y: auto;
  height: calc(100% - 175px);
  border-bottom: solid 1px var(--v-background-lighten4);
}
.v2 {
  height: calc(100% - 140px);
}
</style>
